/** For when you just need to prevent default and not do anything else */
export function preventDefault(e: React.SyntheticEvent) {
  e.preventDefault()
}

// For when you just need to stopPropagation and not do anything else
export function stopPropagation(e: React.SyntheticEvent) {
  e.stopPropagation()
}
